import React, { FC } from 'react';
import { HomepageRoute } from 'src/public/publicRoutes';
import { LogoLeftPanel } from 'src/common/images/LogoLeftPanel';
import styled from 'styled-components';
import { PartnerLogoDesktop } from 'src/common/components/PartnerLogoDesktop';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';

const Container = styled.div`
  width: 100%;
`;

const StyledLink = styled(GatsbyLink)`
  display: inline-block;
  margin: 2.375rem 0 0 1.25rem;
  width: 100%;
`;

const StyledPartnerLogoDesktop = styled(PartnerLogoDesktop)`
  && {
    margin-left: 1.25rem;
    margin-top: 0.9375rem;
  }
`;

export const LayoutPanelLogoAndPartner: FC = () => {
  return (
    <Container>
      <StyledLink to={HomepageRoute}>
        <LogoLeftPanel />
      </StyledLink>
      <StyledPartnerLogoDesktop />
    </Container>
  );
};
